import DE_TERMS_AND_CONDITIONS_PAGE_CONSTANTS from './de'
import EN_TERMS_AND_CONDITIONS_PAGE_CONSTANTS from './en'
import FR_TERMS_AND_CONDITIONS_PAGE_CONSTANTS from './fr'
import HU_TERMS_AND_CONDITIONS_PAGE_CONSTANTS from './hu'
import { T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const TERMS_AND_CONDITIONS_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS> =
  {
    hu: HU_TERMS_AND_CONDITIONS_PAGE_CONSTANTS,
    en: EN_TERMS_AND_CONDITIONS_PAGE_CONSTANTS,
    fr: FR_TERMS_AND_CONDITIONS_PAGE_CONSTANTS,
    de: DE_TERMS_AND_CONDITIONS_PAGE_CONSTANTS
  }

export default TERMS_AND_CONDITIONS_PAGE_CONSTANTS

export const TERMS_AND_CONDITIONS_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS>()
